/**
 * Helpers for Voluum lander tag CSV ↔ chip list.
 * For Media Devoted | Created By Ciro Autiero
 */

export function parseTagsCsv(csv: string): string[] {
  return csv.split(',').map((s) => s.trim()).filter(Boolean);
}

export function joinTagsCsv(tags: string[]): string {
  return tags.join(', ');
}

export function hasTagInsensitive(list: string[], t: string): boolean {
  const x = t.trim().toLowerCase();
  return x !== '' && list.some((s) => s.toLowerCase() === x);
}

/** Client-side typeahead (full list fetched once; avoids query-key flicker). */
export function tagMatchesNeedle(tag: string, needle: string): boolean {
  const n = needle.trim().toLowerCase();
  if (n === '') return true;
  return tag.toLowerCase().includes(n);
}
